import * as Yup from "yup";

const initialValueInfoProfile = {
  personCode: "",
  firstName: "",
  lastName: "",
  nationalCode: "",
  cardNumber: "",
  mobileNumber: "",
  accountingEmployeeId:"",
  personInfo:{
    fatherName: "",
    birthDate: "",
    placeBirth: "",
    issuingCity: "",
    issuePlaceId:"",
    gender: "",
    phoneNumber: "",
    emergencyContactNumber: "",
    maritalStatusType: "",
    numberOfChildren: "",
    MilitaryServiceStatus: "",
    postalCode: "",
    fieldOfStudy: "",
    educationalDegreeId: "",
    emailAddress: "",
    address: "",
    //MaritalStatusType:'',
    citizenship: "",
    provinceBirthDate: "",
    provincePlaceId: "",
  }
 
};
const intialValuePersonInfo = {
  employmentType: "",
  employeeStatusId: "",
  personGroupId: "",
  ///organizationUnitId: "", removed and Multy Select Replaze
  employmentStartDate: "",
};
const initialValueCompletly = {
  ShabaNumber: "",
  bankName: "",
  cartNumber: "",
};
/**------------------------------------------------------------------------
 *                           Validation information
 *------------------------------------------------------------------------**/
const validationSchemaBasInfo = Yup.object({
  personCode: Yup.string().required("شماره پرسنلی اجبار می باشد"),
  firstName: Yup.string().required(" "),
  lastName: Yup.string().required(" "),
  mobileNumber:Yup.string().matches(/^[0-9]+$/, "فقط مقدار عددی مجاز است"),
  nationalCode: Yup.string()
    .matches(/^[0-9]+$/, "فقط مقدار عددی مجاز است")
    .min(10, "حداقل  10")
    .max(10, "حداکثر  10")
    .required(" "),
    personInfo:Yup.object().shape({

      BirthCertificate:Yup.string().matches(/^[0-9]+$/, "فقط مقدار عددی مجاز است"),
      
      phoneNumber:Yup.string().matches(/^[0-9]+$/, "فقط مقدار عددی مجاز است"),
      emergencyContactNumber:Yup.string().matches(/^[0-9]+$/, "فقط مقدار عددی مجاز است"),
      numberOfChildren:Yup.string().matches(/^[0-9]+$/, "فقط مقدار عددی مجاز است"),
      postalCode:Yup.string().matches(/^[0-9]+$/, "فقط مقدار عددی مجاز است")
    })
});

/**------------------------------------------------------------------------
 *                           Validation personInfo
 *------------------------------------------------------------------------**/
const validationPersonInfo=Yup.object({
    employmentType: Yup.string().required(" "),
    employeeStatusId: Yup.string().required(" "),
    personGroupId: Yup.string().required(" "),
    //organizationUnitId: Yup.string().required(" "),
    employmentStartDate: Yup.string().required(" "),
})

const enumsRender = (data, title) => {
  if (!data || !data[title]) {
    return [];
  }

  return data[title].map((item) => ({
    key: item.description,
    value: item.id,
  }));
};
export {
  initialValueInfoProfile,
  intialValuePersonInfo,
  initialValueCompletly,
  validationSchemaBasInfo,
  validationPersonInfo,
  enumsRender,
};
